<template>
  <!-- 押金管理 -->
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">
      <Row class="loading" :style="loading == true ? '' : 'display:none'">
        <Col class="demo-spin-col" span="8">
          <Spin fix>
            <Icon
              type="ios-loading"
              size="18"
              class="demo-spin-icon-load"
            ></Icon>
            <div>加载中</div>
          </Spin>
        </Col>
      </Row>
      <el-button @click="modals">预收款结转</el-button>
      <el-button @click="modals_all">全部预收款结转</el-button>
      <el-button @click="searchs">搜索</el-button>
      <el-descriptions :column="2" border size="mini" style="margin-top: 10px" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
        <el-descriptions-item label="房产">
          <el-select v-model="text" filterable remote clearable reserve-keyword placeholder="可搜索房产/客户姓名" :remote-method="remoteMethod" :loading="loading" style="width: 100%">
            <el-option v-for="item in selectList" :key="item.id" :label="item.house" :value="item.house"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="计费周期">
          <el-date-picker v-model="form.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
          <span style="margin-left: 1px;margin-right: 1px;">至</span>
          <el-date-picker v-model="form.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
        </el-descriptions-item>

        <el-descriptions-item label="收费项目">
          <el-select v-model="form.chargeitem_id" size="mini" multiple filterable collapse-tags placeholder="收费项目" style="width: 85%;">
              <el-option v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
          </el-select>
          <span style="cursor: pointer;margin-left: 3px;" @click="complete">全选</span>
          <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
        </el-descriptions-item>
        <el-descriptions-item label="">

        </el-descriptions-item>

      </el-descriptions>
      <div style="margin-top: 10px;">注：当预收款余额可以结清一条账单时才会使用</div>
      <v-divider></v-divider>
      <el-table ref="multipleTable" height="50vh" :data="data" border style="width: 100%; margin-top: 10px" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="name" label="客户姓名" />
        <el-table-column prop="house" label="房产" />
        <el-table-column prop="chargeitem_name" label="收费项目" />
        <el-table-column label="计费周期">
          <template slot-scope="data">
            {{ data.row.startDate }}-{{ data.row.endDate }}
          </template>
        </el-table-column>
        <el-table-column prop="order.xsc_ChargeSum" label="应收金额" />
        <el-table-column prop="order.delaySums" label="违约金" />
        <el-table-column prop="order.charge" label="应缴金额" />
        <el-table-column prop="money" label="预收款可结转金额" />
        <el-table-column label="结款后余额">
          <template slot-scope="data">
            {{data.row.money - data.row.order.charge < 0 ? 0 : (data.row.money - data.row.order.charge).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="预收款收费对象" />
      </el-table>
      <v-divider></v-divider>
      <div class="pages" v-if="data">
        <Page
          :total="count"
          :page-size="pageSize"
          @on-change="change"
          show-total
        />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
    </div>
  </div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js";
export default {
  name: "OrderAdvanceCarry",
  data() {
    return {
      selectList: [],
      project_id: "",
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: false,
      datevalue: [],
      maskclosable: false,
      modal: false,
      modal2: false,
      statesModal: false,
      loading: false,
      loadingModal: true,
      unlinkpanels: true,
      options: [],
      payment: [],
      charge: [],
      house: [],
      count: 0,
      pageSize: 12,
      data: [],
      pid: "",
      text: "",
      state: "1",
      url: "",
      fileList: [],
      form: {
        pindex_id: "",
        house_id: "",
        name: "",
        house: "",
        payment_name: "",
        chargeitem_name_id: "",
        money: "",
        charge_date: "",
        bill_type: "",
        bill_number: "",
        remarks: "",
        mark: 1,
        startDate: "",
        endDate: "",
        chargeitem_id:''
      },
      chargeitem:[],
      statesForm: {
        id: "",
        payment_name: "",
        retreat_money: "",
        retreat_date: "",
        remarks: "",
      },
      deposit_type: [],
      date: "",
      detaileds: [],
      money: "",
      pagesc:1,
    };
  },
  components: {
    "erp-tree": () => import("../Common/erp-tree.vue"),
  },
  created() {},
  mounted() {
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/excel?" +
      "login_name=" +
      login +
      "&token=" +
      token;
    //项目列表
    this.$myhttp.get("admin/common/pindex", {
      "Content-Type": "application/json",
    }).then((backdata) => {
      this.options = backdata.data.data;
    });
    this.change(1);
    //加载收款方式
    this.$myhttp
      .get("admin/common/payment", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.payment = backdata.data.data;
      });
    //收费项
    this.$myhttp
      .get("admin/common/getChargeitem", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.deposit_type = backdata.data.data;
      });
    //加载收费大类（费项）
    this.$myhttp
      .get("admin/common/getChargeitem", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //勾选
    handleSelectionChange(row) {
      let ids = [];
      row.map((req) => {
        ids.push(req.id);
      });
      this.checkedCities = ids;
    },
    //树搜索
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      this.pid = project.pindex_id;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.text = tree_str;
      this.form.house = tree_str;
      this.change(1);
      let tree = data.tree;
      // console.log(tree)
      this.form.pindex_id = tree[0].id;
      let _this = this;
      tree.forEach(function (it) {
        if (it.type == "room") {
          _this.form.house_id = it.id;
        }
      });
    },
    //预收款结转
    modals() {
      this.$confirm("确定要预收款结转吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          ERP.showLoading()
          let data = {'state':this.state,'text':this.text,'pid':this.pid,'data':this.form,'checkedCities':this.checkedCities};
          this.$myhttp.post("admin/AdvanceCarry/advanceCarry",data, {
              "Content-Type": "application/x-www-form-urlencoded",
          }).then((backdata) => {
              ERP.hideLoading()
              if(backdata.data.code == 201){
                this.$confirm(''+backdata.data.message, '提示', {
                  confirmButtonText: '关闭',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => { })
                // this.$Message.error(backdata.data.message);
              }else{
                this.$Message.success(backdata.data.message);
                this.change(this.pagesc);
              }
          });
        })
        .catch(() => {
          ERP.hideLoading()
        });
    },

    //全部预收款结转
    modals_all(){
      this.$confirm("确定要全部预收款结转吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          ERP.showLoading()
          let data = {'state':this.state,'text':this.text,'pid':this.pid,'data':this.form,'checkedCities':this.checkedCities};
          this.$myhttp.post("admin/AdvanceCarry/advanceCarry_all",data, {
              "Content-Type": "application/x-www-form-urlencoded",
          }).then((backdata) => {
              ERP.hideLoading()
              if(backdata.data.code == 201){
                this.$confirm(''+backdata.data.message, '提示', {
                  confirmButtonText: '关闭',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => { })
                // this.$Message.error(backdata.data.message);
              }else{
                this.$Message.success(backdata.data.message);
                this.change(this.pagesc);
              }
          });
        })
        .catch(() => {
          ERP.hideLoading()
        });
    },

    //分页
    change(page) {
      this.pagesc = page;
      this.loading = true;
      let data = {'page':page,'state':this.state,'text':this.text,'pid':this.pid,'data':this.form};
      this.$myhttp.post("admin/AdvanceCarry/index", data, {
          "Content-Type": "application/x-www-form-urlencoded",
      }).then((backdata) => {
          let data = backdata.data;
          this.data = data.data.data;
          this.cities = data.data.id;
          this.count = data.data.count;
          this.pageSize = data.data.pageSize;
          this.loading = false;
      });

      // this.$myhttp.get("admin/AdvanceCarry/index?page=" +page +"&state=" +this.state +"&text=" +this.text +"&pid=" +this.pid,{
      //   "Content-Type": "application/json",
      // }).then((backdata) => {
      //     let data = backdata.data;
      //     this.data = data.data.data;
      //     this.cities = data.data.id;
      //     this.count = data.data.count;
      //     this.pageSize = data.data.pageSize;
      //     this.loading = false;
      //   });
    },
    //搜索
    searchs() {
      this.money = "--";
      this.change(1);
    },
    //弹窗不要关闭
    loadingModals() {
      let _this = this;
      _this.loadingModal = false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    //全选
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.form.chargeitem_id = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.form.chargeitem_id = [];
    },
  },
  watch: {
    "form.pindex_id"(pid) {
      if (pid != "") {
        this.$myhttp
          .get("admin/Temporary/getHouse?pid=" + pid, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.house = backdata.data.data;
          });
      }
    },
  },
};
</script>

<style>
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #3e3f42 !important;
  cursor: not-allowed;
}
</style>

<style scoped>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  position: fixed;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/advanceCarry.vue